import { shallowEqual, useSelector } from "react-redux";
import { LoadedDestinationInfo } from "../types/global";
import { DestinationState } from "../reducers/destinations";

export default function useDestinationById(id: string) {
  return useSelector((state: { destinations: DestinationState }) => {
    return state.destinations.data[id];
  }, shallowEqual) as LoadedDestinationInfo | undefined;
}
